import * as React from "react";

import "./ml-card.scss";

import {isApiTrue}                      from "@Common/logic/is-api-true";
import {UseState}                       from "@Common/react/use-state";
import {cs}                             from "@Common/react/chain-services";
import {consumeContext}                 from "@Common/react/context";
import {formatDate1}                    from "@Common/ui-components/format-date";
import {DownloadActionInTable}          from "@Xpresso/../../common/ui-components/heavy/common/design2/data-table-ui/download-action-in-table/download-action-in-table";
import {AddressListTypeIcon}            from "@Common/ui-components/heavy/mailing-ui/mailing-icons/address-list-type-icon";
import {faEllipsis, faPencil, faClose}  from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}                from "@fortawesome/react-fontawesome";
import {ConfirmDialog}                  from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {EditMailingListModalMobile}     from "../edit-mailing-list-modal-mobile/edit-mailing-list-modal-mobile";
import {DownloadMailingList}            from "../../download-mailing-list";

export const MlCard = ({entityId, mailingList, mailingLists}) => cs(
    ["menuExpanded", ({}, next) => UseState({
        initValue: false,
        next,
    })],
    ["editMailingListModalMobile", ({}, next) => EditMailingListModalMobile({mailingList, entityId, next})],
    consumeContext("apis"),
    consumeContext("company"),
    ["allowAddressListDownload", ({company}, next) => next(company?.prefs?.allowAddressListDownload)],
    ["confirmDialog", ({}, next) => ConfirmDialog({next})],
    ["downloadMailingList", ({}, next) => DownloadMailingList({
        next,
        mailingList,
    })],   
    ({apis, menuExpanded, editMailingListModalMobile, downloadMailingList, confirmDialog, allowAddressListDownload}) => (
        <div className="m1-card-Be3Al2" >

            <div className="m1-card-column data">
                <div className="m1-card-name">
                    {mailingList.mailingListName}
                </div>
                <div className="m1-card-data-row">
                    <div className="m1-card-column-inner">
                        <div className="m1-card-label">
                            Quantity
                        </div>
                        <div className="m1-card-value">
                            {mailingList.count}
                        </div>
                    </div>
                    <div className="m1-card-column-inner">
                        <div className="m1-card-label">
                            Created
                        </div>
                        <div className="m1-card-value">
                            {formatDate1(new Date(mailingList.dateCreated))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="m1-card-column type">
                <AddressListTypeIcon 
                    value={mailingList.type} 
                    xdQaName={mailingList.mailingListName}
                />                
            </div>

            <div className="m1-card-column options">
                <div 
                    className="m1-card-icon-ellipsis"
                    onClick={(e) => {
                        e.stopPropagation()
                        menuExpanded.onChange(!menuExpanded.value)
                    }}
                >
                    <FontAwesomeIcon 
                        icon={faEllipsis}
                        className='icon-ellipsis'
                    />
                    {
                        <div className={
                            menuExpanded.value 
                            ?
                            "m1-card-options expanded"
                            :
                            "m1-card-options"
                        }>
                        {
                            isApiTrue(mailingList.purchaseRequired) 
                            ? 
                            <div className="ml-card-buy-list" xd-qa-type="label" xd-qa-name={mailingList.mailingListName + " BUY"}>
                                BUY
                            </div>
                            :
                            <>
                                <div 
                                    className='ml-card-edit-list'
                                    onClick= { (e) => {
                                        e.stopPropagation()
                                        if(!menuExpanded.value) {
                                            return
                                        }
                                        editMailingListModalMobile.show({})
                                    }} 
                                >
                                    <FontAwesomeIcon 
                                        icon={faPencil}
                                        className='icon-pencil icon'
                                        
                                    /> 
                                </div>
                                <div className="ml-card-download-list">
                                {
                                    allowAddressListDownload &&
                                    DownloadActionInTable({
                                        onDownload: async () => {
                                            if(!menuExpanded.value) {
                                                return
                                            }
                                            downloadMailingList({mailingList})
                                        },
                                        xdQaName: mailingList.mailingListName
                                    })
                                }                                    
                            </div>         
                            </>
                                
                        }
                            <div 
                                className='ml-card-delete-list' 
                                onClick={ async (e) => {
                                    e.stopPropagation()
                                    if(!menuExpanded.value) {
                                        return
                                    }
                                    const confirmed = await confirmDialog.show({ message: `${CONFIRM_DELETE} ${mailingList.mailingListName}`})
                                    if(confirmed) {                                           
                                        apis.next.mailing.deleteMailingList({id: mailingList.id, entityId})
                                        mailingLists.change((mailingListsUpdated) => 
                                            mailingListsUpdated.filter((mailingListUpdated) => mailingListUpdated.id !== mailingList.id))                                           
                                    }
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={faClose}
                                    className='icon-close icon'                                        
                                />
                            </div>                                  
                        </div>
                    }
                </div>
            </div>

        </div> 
    )
);

const CONFIRM_DELETE = 'This mailing list will be deleted:'
